export const validateChatUrl = (channelId, data) => {
  return { apiUrl: `/channel-log/check-expired/${channelId}`, data };
};
